import { useState, React } from 'react';
import { TableHead, Button, Modal, Box, Typography , IconButton, CircularProgress} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import axios from 'axios';
import CloseIcon from "@mui/icons-material/Close";
import { toast } from 'react-toastify';


const viewPDFTaxFile = ({isFileModalOpen, setIsFileModalOpen, fileData}) => {
  
    const [loading, setLoading] = useState(false);
  const handleDownloadSinglePdf = async (fileName, fileContent, fortnoxFileId, createdDate) => {
      try {
        setLoading(true);
        const blobLaunchedDate = new Date('2024-11-14');
        blobLaunchedDate.setHours(0, 0, 0, 0);
        const fileCreatedDate = new Date(createdDate);
        fileCreatedDate.setHours(0, 0, 0, 0);
        let fileBytes;
        let res;
        if (fileContent !== '') {
          fileBytes = fileContent;
        } else if (fileName && fileCreatedDate >= blobLaunchedDate) {
          res = await axios.get(`/admin/invoice/download/${fileName}`);
          fileBytes = res?.data?.response;
        } else {
          res = await axios.get(`/admin/invoice/download/fortnox-file/${fortnoxFileId}`);
          fileBytes = res?.data?.response;
        }
        const linkSource = `data:application/pdf;base64,${fileBytes}`;
        const downloadLink = document.createElement('a');
        downloadLink.href = linkSource;
        downloadLink.download = fileName.endsWith('.pdf') ? fileName : `${fileName}.pdf`;
        downloadLink.click();
  
        setLoading(false);
      } catch (error) {
        toast.error(error.response.data.message);
        setLoading(false);
      }
    };

  return (

  <Modal
  open={isFileModalOpen}
  onClose={() => setIsFileModalOpen(false)}
  aria-labelledby="file-data-modal-title"
  aria-describedby="file-data-modal-description"
>
  <Box
    sx={{
      padding: 3,
      backgroundColor: "white",
      margin: "auto",
      top: "50%",
      position: "absolute",
      left: "50%",
      transform: "translate(-50%, -50%)",
      overflow: "hidden",
      height: "auto",
      maxHeight: "80vh",
      width: "90vw",
      maxWidth: "700px",
      borderRadius: "10px",
      boxShadow: 3,
      display: "flex",
      flexDirection: "column",
    }}
  >
    <IconButton
      onClick={() => setIsFileModalOpen(false)}
      sx={{
        position: "absolute",
        top: 10,
        right: 10,
        color: "black",
        backgroundColor: "#f5f5f5",
        "&:hover": {
          backgroundColor: "#e0e0e0",
        },
      }}
    >
      <CloseIcon />
    </IconButton>

    <Typography id="file-data-modal-title" variant="h6" component="h2" sx={{ textAlign: "center", mb: 2 }}>
      File Details
    </Typography>

    <TableContainer component={Paper} sx={{ overflowX: "auto", maxHeight: "60vh" }}>
   
      <Table sx={{ minWidth: 650 }} aria-label="file data table" stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell><strong>File Name</strong></TableCell>
            <TableCell><strong>Is File Attached</strong></TableCell>
            <TableCell><strong>Actions</strong></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
           {loading ? (
            <TableRow>
              <TableCell colSpan={3} align="center">
                <CircularProgress />
              </TableCell>
            </TableRow>
          ) : (
          fileData.map((data, i) => (
            <TableRow hover key={i} tabIndex={-1}>
              <TableCell align="left" style={{ padding: '6px 16px' }}>
                {data?.fileName}
              </TableCell>
              <TableCell align="left" style={{ padding: '6px 16px' }}>
                {data?.isFileAttached ? 'Yes' : 'No'}
              </TableCell>
              <TableCell align="left" style={{ padding: '6px 16px' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() =>
                    handleDownloadSinglePdf(data?.fileName, data?.fileContent, data?.fortnoxFileId, data?.createdDate)
                  }
                >
                  Download
                </Button>
              </TableCell>
            </TableRow>
          ))
          )}
        </TableBody>
      </Table>
    </TableContainer>
  </Box>
</Modal>
  )
}
export default viewPDFTaxFile;

